import { DeliveryZone } from '@delivery/const';
import { StateUtils } from '@spartacus/core';
import { DELIVERY_ZONES } from '../delivery-state';

export const LOAD_DELIVERY_ZONES = '[Delivery] Load delivery polygons';
export const LOAD_DELIVERY_ZONES_FAIL = '[Delivery] Load delivery polygons Fail';
export const LOAD_DELIVERY_ZONES_SUCCESS = '[Delivery] Load delivery polygons Success';
export const LOAD_DELIVERY_ZONES_RESET = '[Delivery] Load delivery polygons Reset';

export class LoadDeliveryZones extends StateUtils.EntityLoadAction {
  readonly type = LOAD_DELIVERY_ZONES;

  constructor(code: string) {
    super(DELIVERY_ZONES, code);
  }
}

export class LoadDeliveryZonesFail extends StateUtils.EntityFailAction {
  readonly type = LOAD_DELIVERY_ZONES_FAIL;

  constructor(
    public payload: any,
    code: string,
  ) {
    super(DELIVERY_ZONES, payload, code);
  }
}

export class LoadDeliveryZonesSuccess extends StateUtils.EntitySuccessAction {
  readonly type = LOAD_DELIVERY_ZONES_SUCCESS;

  constructor(
    public payload: DeliveryZone[],
    code: string,
  ) {
    super(DELIVERY_ZONES, code);
  }
}

export class ResetDeliveryZones extends StateUtils.EntityRemoveAllAction {
  readonly type = LOAD_DELIVERY_ZONES_RESET;

  constructor() {
    super(DELIVERY_ZONES);
  }
}

export type DeliveryZonesActions =
  | LoadDeliveryZones
  | LoadDeliveryZonesSuccess
  | LoadDeliveryZonesFail
  | ResetDeliveryZones;
